import { ISendOTPPostResponse, Phase } from './../types/outerLayout/auth';
import { getCookie, getRemainingDateUTC, removeCookie } from '@unified-checkout/kit-components';
import { IProfile } from '../types';
import { QueryClient } from '@tanstack/react-query';

export const classNames = (...names: (string | boolean)[]) =>
  names.filter(Boolean).join(' ');

export const logoutHandler = (queryClient: QueryClient | null = null) => {
  removeCookie('fastCheckoutAccount');
  if (queryClient) {
    queryClient.clear();
  }
  // window.location.reload();
};

export const userDataMapper: (
  userData: Partial<ISendOTPPostResponse>,
  currentPhase: Phase
) => IProfile = (userData, currentPhase) => {
  const {
    customer_id,
    email,
    phone_number,
    full_name,
    is_email_verified,
    is_phone_verified,
    account_status,
    session_token,
    login_token,
  } = userData;

  const profile = {
    customerId: customer_id!,
    email: email!,
    phone: phone_number!,
    fullName: full_name,
    isEmailVerified: is_email_verified,
    isPhoneVerified: is_phone_verified,
    ...(account_status && {accountStatus: account_status}),
    currentPhase,
    ...(session_token && {
      sessionToken: {
        value: session_token,
        expirationDate: getRemainingDateUTC({ unit: 'day', value: 7 }),
      },
    }),
    ...(login_token && {
      loginToken: {
        value: login_token,
        expirationDate: getRemainingDateUTC({ unit: 'minute', value: 15 }),
      },
    }),
  };
  return profile;
};

export const getUserData = () => {
  const cookieAccount = getCookie('fastCheckoutAccount');
  const account: IProfile = JSON.parse(cookieAccount || '{}');
  
  return account;
};